<h1 mat-dialog-title class="text-center">ADD AN ADDITIONAL CHANNEL TO YOUR ACCOUNT (Adds $49/month)</h1>
<div mat-dialog-actions>
  <button mat-flat-button mat-dialog-close class="w-100" color="primary" (click)="handleCreateChannel()">
    ADD CHANNEL NOW
  </button>
  <button mat-button mat-dialog-close class="w-100">CANCEL</button>
</div>
